"use client";

import CustomImage from '@/components/image';
import styles from './_hcp-hero.module.scss';
import { useContext, useEffect, useMemo, useRef } from 'react';
import { LayoutContext } from '@/components/layout-context-container';
import HcpSubnavTabs from '../subnav-tabs';
import { useRouter } from 'next/router';

export default function HcpHero({
  imageSrc = undefined,
  imageProps = null,
  backgroundImageSrc = undefined,
  theme = undefined,
  subnav = null,
  subnavItems = undefined,
  subnavIndex = undefined,
  setSubnavIndex = undefined,
  isCustom = false,
  children
}) {
  const router = useRouter();
  const { showMobileMenu } = useContext(LayoutContext);
  const containerRef = useRef(null);
  const containerClass = useMemo(() => {
    let className = styles.container;

    if (theme) {
      className = `${className} ${styles[theme]}`;
    }

    return className;
  }, [theme])

  useEffect(() => {
    !theme && backgroundImageSrc && containerRef.current?.style.setProperty('--background-imgage-src', `url(${backgroundImageSrc})`);
    !backgroundImageSrc && containerRef.current?.style.setProperty('--background-imgage-src', `unset`);

  }, [backgroundImageSrc, theme, router.asPath]);

  return (
    <div className={containerClass} ref={containerRef}>
      <div className={`${styles.background} hcp-hero__background`} />
      {!showMobileMenu && imageSrc && <div className={`container--large ${styles.image_wrapper}`}>
        <div className={styles.image}>
          <CustomImage
            key={imageSrc}
            src={imageSrc}
            alt=""
            fetchPriority="high"
            loading="eager"
            {...imageProps}
          />
        </div>
      </div>}
      <div className='container'>
        {!isCustom && <div className={`${styles.content}  hcp-hero__content`}>
          <span className={`h1 ${styles.heading}`}>{children}</span>
        </div>}
        {isCustom && <>{children}</>}
      </div>
      {subnavItems && <HcpSubnavTabs subnavItems={subnavItems} setSubnavIndex={setSubnavIndex} subnavIndex={subnavIndex} />}
    </div>
  );
}